import { render, staticRenderFns } from "./BackgroundWebgl.vue?vue&type=template&id=51fab176&"
import script from "./BackgroundWebgl.vue?vue&type=script&lang=js&"
export * from "./BackgroundWebgl.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundWebgl.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports